import React, { useState } from "react";
import Header from "../../components/Header/Header";
import s from "./Reports.module.scss";
import { FilePdfOutlined, DownloadOutlined } from "@ant-design/icons";
import Footer from "../../components/Footer/Footer";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import { useSelector } from "react-redux";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
import { useTranslation } from "react-i18next";

const Reports = () => {
  const { height, width } = useWindowDimensions();
  const { t } = useTranslation();

  const reports = useSelector((state) => state.application.reports);

  const downloadFile = async (id) => {
    if (id === 1) {
      const fileUrl = "/agreement.pdf";
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = "СОГЛАШЕНИЕ.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    if (id === 2) {
      const fileUrl = "/УСТАВ.pdf";
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = "УСТАВ.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const openFileInNewWindow = (e, file) => {
    e.preventDefault();
    const fileUrl = file;
    window.open(fileUrl, "_blank");
  };

  return (
    <div className={s.reports_wrapper}>
      {width > 970 ? <Header /> : <MobileHeader />}
      <div className={s.reports}>
        <h2 className={s.h2}>{t("policies")}</h2>
        <div className={s.subtitle}> {t("policiesIntro")}</div>
        <div className={s.documents}>
          {Array.isArray(reports) &&
            reports.map((it) => (
              <div className={s.documents_item}>
                <button
                  className={s.title}
                  onClick={(e) => openFileInNewWindow(e, it.file)}
                >
                  <FilePdfOutlined className={s.icon} /> &nbsp;{it?.name}
                </button>
                <div className={s.btn} onClick={() => downloadFile(it.id)}>
                  <DownloadOutlined />
                </div>
              </div>
            ))}
        </div>
      </div>

      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default Reports;
